module.exports = __webpack_public_path__ + "img/close.b0aa3045.svg";